export { default as LockCloseIcon } from './LockCloseIcon';
